import {
  cn
} from "./O62HZC57.jsx";
import {
  IconChevronDown
} from "./WHJJ2L4B.jsx";

// src/Expand/Expand.tsx
import { createContext, createEffect, createSignal, splitProps, useContext } from "solid-js";
import { Dynamic } from "solid-js/web";
var ExpandContext = createContext();
var useExpandContext = () => {
  const context = useContext(ExpandContext);
  if (!context) throw new Error("ExpandContext not found");
  return context;
};
var Expand = (props) => {
  const [local, rest] = splitProps(props, ["defaultOpen", "onOpenChange", "open"]);
  const [open, setOpen] = createSignal(local.defaultOpen ?? false);
  const _setOpen = (open2) => {
    setOpen(open2);
    local.onOpenChange?.(open2);
  };
  createEffect(() => {
    if (local.open !== void 0) {
      _setOpen(local.open);
    }
  });
  return <ExpandContext.Provider value={{ open, setOpen: _setOpen }}>
      <div {...rest} />
    </ExpandContext.Provider>;
};
var ExpandTrigger = (props) => {
  const { open, setOpen } = useExpandContext();
  const [params, rest] = splitProps(props, ["as"]);
  return <Dynamic component={params.as ?? "button"} onPointerUp={() => setOpen(!open())} {...rest} />;
};
var ExpandContent = (props) => {
  const { open } = useExpandContext();
  return <div class={cn("grid grid-rows-[0fr] transition-all duration-300 ease-in-out", { "grid-rows-[1fr]": open() })}>
      <div class="overflow-y-hidden">{props.children}</div>
    </div>;
};
var ExpandIndicator = () => {
  const { open } = useExpandContext();
  return <IconChevronDown class="size-4 transition-transform duration-300 ease-in-out" classList={{ "rotate-180 text-primary": open() }} />;
};
var ExpandWrap = Object.assign(Expand, {
  Trigger: ExpandTrigger,
  Content: ExpandContent,
  Indicator: ExpandIndicator
});

export {
  ExpandWrap
};
